import { Calendar as CalendarIcon } from "lucide-react";
import { ALL } from "../../lib/useAnalyticsScope";
import { rangeLabel } from "../../lib/msdAnalytics";
import { DateRangePicker } from "../DateRangePicker";
import { PageHead, Seg, SelectBox } from "./analytics";

const NO_ACTIVITY = new Map();

// The title, date range and location / region / dealer filters that sit on top
// of every analytics page. They all drive the same scope, so the pages agree.
export function AnalyticsHead({ scope, title, description, divider }) {
  const { range } = scope;
  return (
    <PageHead
      title={title}
      description={description}
      divider={divider}
      range={
        <DateRangePicker
          range={range}
          onChange={scope.setRange}
          activity={NO_ACTIVITY}
          trigger={() => (
            <button
              type="button"
              className="inline-flex h-9 items-center gap-2 rounded-[10px] border border-msd-line bg-msd-surface px-3 text-[13px] font-medium text-msd-ink hover:border-msd-line2"
              data-testid="date-range-trigger"
              title="Change dates"
            >
              <CalendarIcon size={15} className="text-msd-muted" />
              {rangeLabel(range)}
            </button>
          )}
        />
      }
    >
      {scope.locationChips.length > 1 && (
        <Seg
          label="Location"
          value={scope.loc}
          onChange={scope.setLoc}
          options={scope.locationChips.map((l) => [l, l === ALL ? "All locations" : l])}
        />
      )}
      {scope.showRegionFilter && (
        <SelectBox value={scope.regionId} onChange={scope.setRegionId} label="Region" testid="analytics-region-select">
          <option value={ALL}>All regions</option>
          {scope.regionOptions.map((r) => (
            <option key={r.id} value={String(r.id)}>
              {r.name}
            </option>
          ))}
        </SelectBox>
      )}
      {scope.showDealerFilter && (
        <SelectBox value={scope.dealerId} onChange={scope.setDealerId} label="Dealer" testid="analytics-dealer-select">
          <option value={ALL}>All dealers</option>
          {scope.dealerOptions.map((d) => (
            <option key={d.id} value={String(d.id)}>
              {d.name}
            </option>
          ))}
        </SelectBox>
      )}
    </PageHead>
  );
}
